<template>
	<page>
		<module>
			<view-list ref="view" work-type="12" selector :view-config="auth('b_supplier_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="供应商编号">
							<c-input name="supplier_code"></c-input>
						</m-search-item>
						<m-search-item label="供应商名称">
							<c-input name="supplier_name"></c-input>
						</m-search-item>
						<m-search-item label="供应商全称">
							<c-input name="supplier_full_name"></c-input>
						</m-search-item>
						<m-search-item label="联系人名称">
							<c-input name="contact_name"></c-input>
						</m-search-item>
						<m-search-item label="联系电话">
							<c-input name="contact_phone"></c-input>
						</m-search-item>
						<m-search-item label="联系地址">
							<c-input name="contact_address"></c-input>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button color="main" v-if="auth('b_supplier_edit')" v-lock="lock('b_supplier_edit')" prepend-icon="tf-add" @click="editSupplier()">创建供应商</c-button>
					<c-button v-if="auth('b_supplier_export')" v-lock="lock('b_supplier_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_supplier_export')" v-lock="lock('b_supplier_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_supplier_edit')" v-lock="lock('b_supplier_edit')" prepend-icon="tf-import" @click="$refs.view.excelImport()">导入</c-button>
				</template>
				
				<template #batchOperate="{data}">
					<c-button v-if="auth('b_supplier_export')" v-lock="lock('b_supplier_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_supplier_export')" v-lock="lock('b_supplier_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_supplier_edit')" v-lock="lock('b_supplier_edit')" prepend-icon="tf-trash" color="red" :hollow="true" @click="batchRemoveSupplier">删除</c-button>
				</template>

				<template #otherOperate>
					<c-button v-if="auth('b_supplier_log')" v-lock="lock('b_supplier_log')" hollow prepend-icon="tf-import-record" @click="$refs.view.loadImportLogDetail()">导入记录</c-button>
					<c-button v-if="auth('b_supplier_log')" v-lock="lock('b_supplier_log')" prepend-icon="tf-operate-record" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
				</template>
				
				<c-table-column
					type="button"
					label="操作"
					width="110"
					button-limit="2"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_supplier_edit')" v-lock="lock('b_supplier_edit')" icon="tf-edit" @click="editSupplier(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_supplier_edit')" v-lock="lock('b_supplier_edit')" icon="tf-trash" color="red" @click="removeSupplier(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		data() {
			return {
			}
		},

		computed: {
			// 获取dictName选项数据
			...mapState(['openCloseDic'])
		},
		
		methods: {
			/******新建/编辑供应商*******/
			editSupplier(data) {
				this.globalDialog('supplierEdit', {
					data:data
				}, this.$refs.view.update)
			},
			
			/****批量删除供应商***/
			batchRemoveSupplier(){
				var ids = [];
				this.$refs.view.$refs.list.getData('selected').forEach(item => {
					ids.push(item.id);
				});
				
				this.$confirm({
					message:'确认删除' + ids.length + '条供应商记录吗？删除后不可恢复',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/supplier/remove/batch',
							data: {ids: ids},
							loading: true,
							success: data => {
								let Mtype = 'success';
								let message = '成功' + data.success_count + '条';
								if(data.fail_count > 0 && data.success_count > 0){
									Mtype = 'warn';
									message += '，失败'+data.fail_count+'条';
								}else if(data.fail_count > 0 && data.success_count == 0){
									Mtype = 'fail'
									message += '，失败'+data.fail_count+'条';
								}else{
									message = '成功删除' + data.success_count + '条记录';
								}
								this.$message({
									message: message,  // 提示内容,
									type: Mtype
								});
								//刷新
								this.$refs.view.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
			
			/******删除供应商************/
			removeSupplier(data){
				this.$confirm({
					message:'确认删除供应商【'+data.supplier_name+'】？删除后不可恢复',  // 提示内容,
					// buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/supplier/remove',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								//刷新
								this.$refs.view.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
		}
	}
</script>

<style lang="stylus" scoped>
</style>